import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../Container';

export const FormContainer = styled(Container)`
  padding-bottom: 1.875rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-bottom: 2.5rem;
  }
`;

export const Form = styled.form`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0;
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 20.313rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 34.375rem;
  }
`;

export const PredictiveSearchContainer = styled.ul`
  list-style-type: none;
  border-radius: 5px;
  background-color: ${({ themes }) =>
    themes === 'dark'
      ? themeGet('colors.grey-mild')
      : themeGet('colors.white')};
  box-shadow: 0 2px 16px 0 rgba(43, 44, 50, 0.28);
  width: 100%;
  z-index: 10;
  margin: 0;
  position: absolute;
  top: 115%;

  li {
    margin-bottom: 0;
    a,
    button {
      color: ${themeGet('colors.body-copy')};
      font-size: 1rem;
      font-stretch: normal;
      font-style: normal;
      font-weight: ${themeGet('fontWeights.normal')};
      line-height: 1.67;
      letter-spacing: normal;
      display: inline-block;
      text-align: left;
      width: 100%;
      padding: 0.469rem 1.25rem;
      transition: all 300ms ease;

      &:focus,
      &:hover {
        opacity: 1;
        color: ${({ themes }) =>
          themes === 'dark'
            ? themeGet('colors.white')
            : themeGet('colors.btnRedBg')};
        font-weight: ${themeGet('fontWeights.medium')};
        text-decoration: underline;
      }

      & > svg {
        display: none;
      }

      span {
        padding-bottom: 0;
        border-bottom: none;
        font-weight: inherit;
      }
    }

    &:first-child {
      a,
      button {
        padding-top: 0.938rem;
      }
    }

    &:last-child {
      a,
      button {
        padding-bottom: 0.938rem;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    li {
      margin-bottom: 0;
      a,
      button {
        font-size: 1.125rem;
        line-height: 1.875rem;
        padding: 0.469rem 1.625rem;
    }
  }
`;
